import { doc, writeBatch } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import BinIconOutlined from "../assets/icons/binIconOutlined";
import PencilIcon from "../assets/icons/pencilIcon";
import { firestoredDB } from "../config/firebase";
import { playAudio } from "../utils/btnAudio";
import { CButton } from "./CommonComponents";
import { FaPen, FaTrash } from "react-icons/fa";
import { updateListOrder } from "../utils/apiServices/cookbookServices";
import { Dark_White_mode } from "../utils/constants";

const CookBookLists = ({
  openModal,
  clickedListId,
  loading,
  listsData,
  onListClick,
  onDeleteIconClick,
  onPencilIconClick,
  search = "",
  onDragStart,
  onDragEndCustom,
}) => {
  const { subscriptionId, subScriptionPlan, subscriptionStatus } = useSelector(
    (state) => state.tokens
  );
  const [items, setItems] = useState(listsData);

  const handleListUpdate = async (orderedData) => {
    try {
      await updateListOrder(orderedData);

      console.log("List order updated successfully");
    } catch (err) {
      console.error("Error updating list order: ", err);
    }
  };

  // a little function to help us with reordering the result
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const onDragEnd = (result) => {
    onDragEndCustom();
    if (!result.destination) {
      return;
    }

    const reorderedItems = reorder(
      items,
      result.source.index,
      result.destination.index
    );
    setItems(reorderedItems);
    handleListUpdate(reorderedItems);
  };
  const setData = () => {
    // if (items?.length == 0) {
    setItems(listsData);
    // }
  };

  const handleOpenModal = () => {
    if (
      subscriptionStatus === true &&
      (subScriptionPlan === "Basic" || subScriptionPlan === "Free") &&
      items.length >= 10
    ) {
      Swal.fire({
        icon: "error",
        title:
          "You have reached the maximum number of lists for your subscription plan",
        showConfirmButton: true,
        confirmButtonText: "Upgrade Plan",
        confirmButtonColor: "#FF6B3B",
        showCancelButton: true,
        cancelButtonText: "Cancel",
        cancelButtonColor: "#FF6B3B",
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = "/shop";
        }
      });

      return;
    }

    openModal();
  };

  useEffect(() => {
    setData();
  }, [listsData]);

  return (
    <div
      // id="no-scrollbar"

      // className="no-scrollbar overflow-y-scroll max-h-[300px] sm:max-h-[calc(100%-50px)] flex-[30%]  flex-wrap h-auto md:py-5 w-full justify-start items-start  flex-row md:space-x-0 space-x-2 bg-white bg-opacity-30 rounded-xl"
      className=" max-h-[300px] sm:max-h-[calc(100%-50px)] flex-[30%] flex-wrap h-auto  w-full !bg-white !dark:bg-orange-300 justify-start items-start flex-row md:space-x-0 space-x-2  bg-opacity-30 rounded-xl overflow-y-scroll"
    >
      <div className="flex flex-col md:overflow-x-hidden overflow-x-scroll items-center justify-center px-4 py-6 no-scrollbar bg-white dark:bg-orange-300">
        {/* <button
          onClick={handleOpenModal}
          className="rounded-full lg:w-52 w-full
bg-gradient-to-r from-orange-100 to-orange-50 hover:from-orange-50 hover:to-orange-100  md:mx-0 
font-medium  flex items-center justify-center border border-transparent lg:px-14 py-2.5
 my-2  text-white transition duration-150 ease-in-out backdrop-blur-lg "
        >
          Create List
        </button> */}
        <CButton
          label={"Create List"}
          variant={"red"}
          size={"middle"}
          className={"w-full"}
          onClick={handleOpenModal}
        />
        <button
          onClick={() => onListClick(null)}
          className={` w-full font-medium text-left  border border-transparent px-2 my-2 text-black py-3 rounded-full  transition duration-150 ease-in-out ${
            clickedListId === null ? "bg-orange-200" : " bg-gray-1100"
          }`}
        >
          <span className="ml-2">General</span>
        </button>
        {loading ? (
          <p>Please wait ...</p>
        ) : items?.length === 0 ? (
          <p className={`text-black text-center text-lg mt-4`}>No Lists..</p>
        ) : (
          <div className="w-full">
            {search?.length == 0 && (
              <DragDropContext onDragEnd={onDragEnd} onDragStart={onDragStart}>
                <Droppable droppableId="droppable">
                  {(provided, snapshot) => (
                    <div ref={provided.innerRef} {...provided.droppableProps}>
                      {items?.map((list, idx) => {
                        return (
                          <Draggable
                            key={list.id}
                            draggableId={list.id}
                            index={idx}
                          >
                            {(provided, snapshot) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <div
                                  key={idx}
                                  className={`w-full md:mx-0 bg-clip-padding px-4  
                            font-medium   flex items-start justify-between cursor-pointer my-2 hover:bg-gray-300 text-black py-3  border border-transparent lg:px-4 
                   
                   rounded-full   transition duration-150 ease-in-out mx-2 shadow-md mb-2 ${
                     clickedListId === list.id
                       ? "bg-orange-200"
                       : "bg-gray-1100"
                   }`}
                                  onClick={() => onListClick(list.id)}
                                >
                                  <div className="">{list.name} </div>
                                  <div className="flex mt-1 space-x-1">
                                    <div
                                      onClick={() => onDeleteIconClick(list.id)}
                                    >
                                      <FaTrash
                                        className={`${
                                          clickedListId === list.id
                                            ? "text-gray-700"
                                            : "text-gray-400"
                                        } mr-1`}
                                      />
                                    </div>
                                    <div
                                      onClick={() => onPencilIconClick(list.id)}
                                    >
                                      <FaPen
                                        className={`${
                                          clickedListId === list.id
                                            ? "text-gray-700"
                                            : "text-gray-400"
                                        }`}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </Draggable>
                        );
                      })}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default CookBookLists;
